import { z } from "zod";

export const dashboardVariableLabelName = z.string().trim().min(1, "Label name cannot be empty").catch("");
